<template>
 <div id="abo">
   <navigation :navigationPlaceholder="navigationPlaceholder"></navigation>
    <b-container fluid class="start-normal border-b">
      <b-row>
        <b-col cols="12" md="1"  class="div-back">
          <a href="javascript:history.back()" class="normallink history-back">
              <svg class="icon-back" width="57px" height="33px" version="1.1" id="Ebene_1"  x="0px" y="0px" viewBox="0 0 57 33" style="enable-background:new 0 0 57 33;" xml:space="preserve">
              <title>back</title>
              <polygon points="56.2,15 6.1,15 18.6,2.6 16.4,0.4 0.4,16.5 16.4,32.6 18.6,30.4 6.1,18 56.2,18 "/>
              </svg>
          </a>
        </b-col>
        <b-col cols="12" md="11">
            <h1> {{ entry.title }} </h1>
            
            <div class="spacing-bio" v-bind:class="{ sidebarBox: entry.showMore, sidebarBoxOpen: sidebarBoxOpen  }"> 
              <p> {{ entry.autorenBio }} </p>
            </div>
            <div v-if="entry.showMore">
                <div class="" @click="readMore =! readMore, sidebarBoxOpen =! sidebarBoxOpen" v-if="readMore">
                  <div class="white-back">
                    <p>Mehr anzeigen…</p>
                  </div>
                </div>     
                <div class="read-less" @click="readMore =! readMore, sidebarBoxOpen =! sidebarBoxOpen" v-else>
                  <p>Weniger anzeigen…</p>
                </div>
              </div>

            <div class="spacing-bio" v-if="entry.autorenMail">
              <p> {{ entry.autorenMail }} </p>
            </div>    
        
        </b-col>
      </b-row>
    </b-container>
    <relatedArticleAuthor :authorId="entry.id"></relatedArticleAuthor>
  </div>
</template>

<script>
  import Navigation from "@/components/_navigation";
  import RelatedArticleAuthor from "@/components/_relatedArticleAuthor";
  const axios = require("axios");

  export default {
    name: "Abo",
  metaInfo: () => ({
    link: [{ rel: "favicon", href: "favicon.ico" }],
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Femina Politica",
    // all titles will be injected into this template
    description: "Description",
  }),
  components: {
    Navigation,
    RelatedArticleAuthor
  },
  data() {
    return {
      entrySlug: this.$route.params.slug,
      entry: [],
      navigationPlaceholder: "Artikel Archiv",
      readMore: true,
      sidebarBoxOpen: false

    };
  },
  created() {
    axios({
      url: "https://craft.femina-politica.de/api",
      method: "POST",
      data: {
        query: `
              query {
                autor:entries(section: "autor", slug: "` + this.entrySlug +`") {
                title,
                uid,
                id
                ... on autor_autor_Entry {
                  autorenBio,
                  showMore,
                  autorenMail
                }              
              }
              }
            `
      }
    }).then((result) => {
    // console.log(result)
    let data = result.data.data.autor[0];
    //console.log(data)
    this.entry = data;
  });
  },
  methods: {
    newLineText(el){
      if(el){
        return el.replace(/(?:\r\n|\r|\n)/g, "<br />");
      }
    }
  }
}
</script>
